// extracted by mini-css-extract-plugin
module.exports = {"root":"InstabookOptionsList_root__7H1RX","title":"InstabookOptionsList_title__uPxWL","loading":"InstabookOptionsList_loading__o8wSR"};